// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"; //导入vue
import App from "./App"; //导入App.vue
import router from "./router"; //导入路由
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Request from "./api/request.js";
import AutoResponsive from "autoresponsive-vue";
Vue.use(AutoResponsive);
Vue.use(ElementUI);
Vue.prototype.$request = Request;
Vue.config.productionTip = false;
Vue.prototype.$globalevent = new Vue();
//将上边的全局变量赋给 vue 实例化，并挂载到 #app上
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});
// main.js 一个管理者，通过实例化 vue，并把组件和入口页面联系起来。
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js